import * as Yup from 'yup';

export const schema = Yup.object().shape({
  SocialManagerAccountToken: Yup.string().required('وارد کردن توکن حساب کاربری الزامی است'),
  SocialManagerAccountKey: Yup.string().required('وارد کردن کلید حساب کاربری الزامی است'),
});
